import { Receipt } from "lucide-react";
import { usePaymentMethods } from "@/lib/paymentMethods";

const formatEur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export function PaymentDetailsSection({ payments }) {
  const pm = usePaymentMethods();
  if (!payments?.length) return null;
  return (
    <div className="border rounded-lg p-3 bg-emerald-50/50 border-emerald-200" data-testid="payment-details-section">
      <div className="flex items-center gap-2 mb-2">
        <Receipt size={15} className="text-emerald-600" />
        <span className="text-sm font-semibold text-emerald-800">Detail des règlements</span>
        <span className="text-xs text-emerald-600 ml-auto">{payments.length} règlement{payments.length > 1 ? "s" : ""}</span>
      </div>
      <div className="space-y-1">
        {payments.map((p, i) => (
          <div key={p.id || i} className="flex items-center justify-between text-sm py-1.5 px-2 bg-white rounded border border-emerald-100">
            <span className="text-slate-600">{p.date ? new Date(p.date).toLocaleDateString("fr-FR") : "-"}</span>
            <span className="text-slate-500" data-testid={`payment-detail-mode-${i}`}>{pm.label(p.mode) || "-"}</span>
            <span className="font-semibold text-emerald-700">{formatEur(p.amount_ttc || p.amount || 0)}</span>
          </div>
        ))}
      </div>
      <div className="flex justify-between mt-2 pt-2 border-t border-emerald-200 text-sm">
        <span className="font-medium text-slate-600">Total réglé</span>
        <span className="font-bold text-emerald-700">{formatEur(payments.reduce((s, p) => s + (p.amount_ttc || p.amount || 0), 0))}</span>
      </div>
    </div>
  );
}
